import { render, staticRenderFns } from "./UnitRepresentatives.vue?vue&type=template&id=2b5837d7&"
import script from "./UnitRepresentatives.vue?vue&type=script&lang=js&"
export * from "./UnitRepresentatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports